import { Injectable } from '@angular/core';
import {
  SubscriptionUpgradeDialogComponent,
  SubscriptionUpgradeDialogData,
  SubscriptionUpgradeReason,
} from './subscription-upgrade-dialog.component';
import { DialogsService } from '../../services/dialogs.service';

@Injectable()
export class SubscriptionUpgradeDialogService {
  constructor(
    private _dialogsService: DialogsService,
  ) {
  }

  public async openSubscriptionUpgradeDialogAsync(reason: SubscriptionUpgradeReason) {
    await this._dialogsService.showDialogAsync<SubscriptionUpgradeDialogData>(SubscriptionUpgradeDialogComponent, {
      data: {
        reason: reason,
      },
    });
  }
}
